import { useEffect, useState } from 'react';
import act from '@flux/actions/actView';

import { Grid, TextInput, Typography, Tabs } from '@ts/storybook';
import Misc from '@components/Misc';
import EventTypeItemRulesTab from './tabs/EventTypeItemRulesTab';
import EventTypeLocationRulesTab from './tabs/EventTypeLocationRulesTab';
import EventTypeTaskRulesTab from './tabs/EventTypeTaskRulesTab';
import EventTypeDevicesTriggerTab from './tabs/EventTypeDevicesTriggerTab';
import EventTypeDistributionsTab from './tabs/EventTypeDistributionsTab';
import EventTypeTemplateTab from './tabs/EventTypeTemplateTab';
//import NotificationConfigForm from '../Configuration/Notifications/NotificationConfigForm';

import WrapperEntitySelector from '@modules/entitySelector/WrapperEntitySelector';
import { GridContainerFullHeight } from '@ts/storybook';
import Events, { defaultConfigComponent as EvConfigComponent } from '../Events/Events';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import WithAllPropsApp from '@utils/wrappers/WithAllPropsApp';
import { IForm, TMode } from '@ts/ui-models';
import { IAppProps } from '@interfaces/App.interface';

interface IEventTypeFormProps extends IForm, IAppProps {}

const EventTypeForm = (props: IEventTypeFormProps) => {
  const [state, setState] = useState({ activeTab: 'main' });

  const { values, mode, onCallbackChange } = props;
  const isViewMode = mode === 'view';

  const tabs = [
    { label: 'Main Information', value: 'main' },
    { label: 'Item Rules', value: 'item' },
    { label: 'Location Rules', value: 'location' },
    { label: 'Task Rules', value: 'task' },
    { label: 'Devices with trigger', value: 'devices' },
    { label: 'Distribution', value: 'distribution' },
    { label: 'Template', value: 'template' },
    /*  { label: 'Notifications', value: 'notifications' }, */
  ];

  //#region Handlers
  const _handleTabChange = (_event, tab) => {
    setState({ activeTab: tab });
    return act.setDataPath('selectedTab', { tab });
  };

  //#endregion

  //#region Renders
  const _renderContents = () => {
    const contents = (() => {
      switch (state.activeTab) {
        case 'main':
          return renderMain();
        case 'item':
          return <EventTypeItemRulesTab {...props} />;
        case 'location':
          return <EventTypeLocationRulesTab {...props} />;
        case 'task':
          return <EventTypeTaskRulesTab {...props} />;
        case 'devices':
          return <EventTypeDevicesTriggerTab {...props} />;
        case 'distribution':
          return <EventTypeDistributionsTab {...props} />;
        case 'template':
          return <EventTypeTemplateTab {...props} />;
        /* case 'notifications':
          return <NotificationConfigForm {...props} />; */
      }
    })();
    return <GridContainerFullHeight id="event-type-page">{contents}</GridContainerFullHeight>;
  };

  const renderMain = () => {
    return (
      <Grid container size={{ xs: 12 }} rowSpacing={2} columnSpacing={1} pb={2} id="general-tab">
        <Grid size={{ xs: 12, md: 12, lg: 6 }} style={{ height: '30vh' }}>
          {renderMainInfo()}
        </Grid>
        <Grid size={{ xs: 12, md: 12, lg: 6 }} style={{ height: '30vh' }}>
          {renderCategories()}
        </Grid>
        {mode !== 'new' && (
          <Grid size={{ xs: 12, md: 12, lg: 12 }} style={{ height: 'auto', minHeight: '75vh', paddingTop: '0!important' }}>
            <Misc.NewPaperWithPadding>
              <Typography variant="h5" text="Events" />
              <Events configComponent={{ ...EvConfigComponent, where: { eventTypeId: values.id } }} />
            </Misc.NewPaperWithPadding>
          </Grid>
        )}
      </Grid>
    );
  };

  const renderCategories = () => {
    return (
      <Misc.NewPaperWithPadding>
        <Typography variant="h5" className="mb-[14px]" text="Categories" />
        <WrapperEntitySelector
          //label="Categories"
          value={values.categories}
          onChange={v => props.onChange('categories', v)}
          searchComponent={generateSearchEntitySelector('category')}
          isReadOnly={isViewMode}
          allowCreateNewEntity
          multiple
        />
      </Misc.NewPaperWithPadding>
    );
  };

  const renderMainInfo = () => {
    return (
      <Misc.NewPaperWithPadding>
        <Typography variant="h5" text="Main Information" />
        <TextInput
          isReadOnly={isViewMode}
          label="Name"
          value={values.name}
          onChangeValue={onCallbackChange('name')}
          infoText="Blank spaces at the beggining and the end will be trimmed on save"
          required={props.requiredFields.includes('name')}
        />
        <TextInput
          isReadOnly={isViewMode}
          label="Custom ID"
          value={values.customId}
          onChangeValue={onCallbackChange('customId')}
          infoText="Blank spaces at the beggining and the end will be trimmed on save"
          required={props.requiredFields.includes('customId')}
          type="ID"
        />
        <TextInput
          isReadOnly={isViewMode}
          label="Notes"
          value={values.notes}
          onChangeValue={onCallbackChange('notes')}
          multiline
        />
      </Misc.NewPaperWithPadding>
    );
  };
  //#endregion

  return (
    <Tabs sticky id={'event-type-page'} tabs={tabs} value={state.activeTab} onChange={_handleTabChange}>
      {_renderContents()}
    </Tabs>
  );
};

export default WithAllPropsApp(EventTypeForm);
